import { Badge, Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const MarkAsViewedButtonsContainer = styled('div')`
  display: none;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`

export const NewLabelOuter = styled('div')`
  padding: 2px 8px;
  background-color: ${colors.primary};
`

export const MarkAllAsViewed = styled(Button)`
  padding: 3px 8px !important;
  border-radius: 0;
  min-height: unset;
  min-width: unset;
  border-bottom: none;
  border-left: none;

  background-color: ${colors.white};

  user-select: none;

  position: relative;

  &:hover {
    border-bottom: none;
    border-left: none;
    cursor: pointer;
  }
`

export const MarkAsViewed = styled(Button)`
  padding: 3px 8px !important;
  border-radius: 0;
  min-height: unset;
  min-width: unset;
  border-top: 1px solid ${colors.primary};
  border-bottom: none;
  border-left: none;

  background-color: ${colors.primary};

  user-select: none;

  &:hover {
    border-bottom: none;
    border-left: none;
    cursor: pointer;
  }
`

export const MarkAsViewedButtonContainer = styled('div')`
  &:hover {
    ${NewLabelOuter} {
      display: none;
    }

    & ${MarkAsViewedButtonsContainer} {
      display: flex;
    }
  }
`

export const NewCountBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    padding: '10px 6px',
    color: '#fff',
    borderRadius: '66px',
    fontWeight: '400',
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 'unset',
    transform: 'translate(0%, -12px)',
  },
}))
